import {combine} from 'effector';
import {createGate} from 'effector-react';

import {
    blockOrganization,
    fetchOrganizationList,
    getOrganizationByTin,
    Organization,
    unblockOrganization,
} from 'api/organizations';
import {createTableModel} from 'core/hooks/table';
import {rootDomain} from 'core/rootDomain';
import {BillingBalance} from 'types/billing';
import {OrganizationPaginationContent} from 'types/profile';

const domain = rootDomain.createDomain('organizationTableDomain');

export const Gate = createGate('OrganizationTableGate');
export const OrganizationGate = createGate<{tin: string | null}>('OrganizationDataGate');

export const fetchDataFx = domain.createEffect({
    name: 'fetchDataFx',
    handler: fetchOrganizationList,
});

export const fetchOrganizationByTinFx = domain.createEffect({
    name: 'fetchOrganizationByTinFx',
    handler: getOrganizationByTin,
});

export const blockOrganizationFx = domain.createEffect({
    name: 'blockOrganizationFx',
    handler: blockOrganization,
});

export const unblockOrganizationFx = domain.createEffect({
    name: 'unblockOrganizationFx',
    handler: unblockOrganization,
});

export const $organizationStatusChangePending = combine(
    blockOrganizationFx.pending,
    unblockOrganizationFx.pending,
    (blockPending, unblockPending) => blockPending || unblockPending,
);

export const organizationBalanceChanged = domain.createEvent<BillingBalance>();

export const {
    filters$,
    filtersChanged,
    pageNumber$,
    pageNumberChanged,
    pageSize$,
    pageSizeChanged,
} = createTableModel({
    domain,
});

export const organizationList$ = domain.createStore<OrganizationPaginationContent | null>(null);
export const organizationData$ = domain.createStore<Organization | null>(null);

export const organizationState$ = combine({
    data: organizationList$,
    filters: filters$,
    pageNumber: pageNumber$,
    pageSize: pageSize$,
    isLoading: fetchDataFx.pending,
});
